define('gigaset_contentbridge/components/slider',[
    "jquery",
    "lodash",
    "cartware/components/_base",
    "text!shoptheme/templates/magnific-popup/default.html",
    "magnific-popup"
], function(
    $,
    _,
    Component,
    PopupHtml
) {
    var _popupTemplate = _.template(PopupHtml);

    return Component.create({
        $init: function() {
            var self = this;

            $('.magnific-trigger').on('click', function(e) {
                e.preventDefault()

                var elem = $(this);
                var modalContent = $(elem.data('target')).html();

                if(modalContent) {
                    $.magnificPopup.open({
                        items: {
                            src: _popupTemplate({
                                body: modalContent
                            }),
                            type: 'inline'
                        }
                    });
                }
            });
        }
    });
});
